import { useCallback, useEffect } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import { integrationService } from '@/modules/integrations/services'
import { useIntegrationStore } from '@/stores/integration-store'

const QUERY_KEY = ['integrations', 'health'] as const

export function useIntegrationHealth() {
  const queryClient = useQueryClient()
  const hydrate = useIntegrationStore((s) => s.hydrate)
  const refreshHealth = useIntegrationStore((s) => s.refreshHealth)
  const ready = useIntegrationStore((s) => s.ready)
  const health = useIntegrationStore((s) => s.health)
  const dashboard = useIntegrationStore((s) => s.dashboard)
  const logs = useIntegrationStore((s) => s.logs)
  const config = useIntegrationStore((s) => s.config)
  const updateConfig = useIntegrationStore((s) => s.updateConfig)
  const refreshLogs = useIntegrationStore((s) => s.refreshLogs)

  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      await hydrate()
      return integrationService.listHealth()
    },
  })

  useEffect(() => {
    if (!ready) void hydrate()
  }, [ready, hydrate])

  const refresh = useCallback(async () => {
    await refreshHealth()
    void queryClient.invalidateQueries({ queryKey: QUERY_KEY })
  }, [refreshHealth, queryClient])

  return {
    ready,
    health: query.data ?? health,
    dashboard,
    logs,
    config,
    updateConfig,
    refreshLogs,
    refresh,
    isLoading: query.isLoading,
    service: integrationService,
  }
}
